// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoWrapper[data-v-0ec1a221]{display:flex;justify-content:center}.default[data-v-0ec1a221]{max-width:104px}@media(min-width:767px){.default[data-v-0ec1a221]{max-width:132px}}@media(min-width:1023px){.default[data-v-0ec1a221]{max-width:60px}}.rectangularLogosBeingUsed[data-v-0ec1a221]{max-width:104px}@media(min-width:1023px){.rectangularLogosBeingUsed[data-v-0ec1a221]{max-width:132px}}.evenlyShapedLogosBeingUsed[data-v-0ec1a221]{max-width:60px}", ""]);
// Exports
module.exports = exports;
